<sgt-multi-select
  [settings]="settings"
  [options]="options"
  [(ngModel)]="idsClassificacoesFaturamento"
  (ngModelChange)="onSelectionChange()"
  (search)="onSearch()"
  (isFirstOpened)="firstOpened($event)">
</sgt-multi-select>
